import {
  HERO_SLIDER,
  HERO_SLIDER_SUCCESS,
  HERO_SLIDER_ERROR,
  FETCH_FRONT_MENU,
  FETCH_FRONT_MENU_SUCCESS,
  FETCH_FRONT_MENU_ERROR,
  FETCH_PARENT_CATEGORIES,
  FETCH_PARENT_CATEGORIES_SUCCESS,
  FETCH_PARENT_CATEGORIES_ERROR,
  FETCH_BRANDS,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_ERROR,
  FETCH_HIGHLIGHTS,
  FETCH_HIGHLIGHTS_SUCCESS,
  FETCH_HIGHLIGHTS_ERROR,
  MOST_POPULAR,
  MOST_POPULAR_SUCCESS,
  MOST_POPULAR_ERROR,
  FETCH_CATEGORY_TREE,
  FETCH_CATEGORY_TREE_SUCCESS,
  FETCH_CATEGORY_TREE_ERROR,
  FETCH_CATEGORY_FILTERS,
  FETCH_CATEGORY_FILTERS_SUCCESS,
  FETCH_CATEGORY_FILTERS_ERROR,
  FETCH_DAILY_DEALS,
  FETCH_DAILY_DEALS_SUCCESS,
  FETCH_DAILY_DEALS_ERROR,
  FETCH_COUPON_DETAILS,
  FETCH_COUPON_DETAILS_SUCCESS,
  FETCH_COUPON_DETAILS_ERROR,
} from '../actionTypes';

export const fetchHeroSlider = (data) => ({
  type: HERO_SLIDER,
  payload: data,
});

export const fetchHeroSliderSuccess = (user) => ({
  type: HERO_SLIDER_SUCCESS,
  payload: user,
});

export const fetchHeroSliderError = (message) => ({
  type: HERO_SLIDER_ERROR,
  payload: message,
});

export const fetchFrontMenu = (data) => ({
  type: FETCH_FRONT_MENU,
  payload: data,
});

export const fetchFrontMenuSuccess = (user) => ({
  type: FETCH_FRONT_MENU_SUCCESS,
  payload: user,
});

export const fetchFrontMenuError = (message) => ({
  type: FETCH_FRONT_MENU_ERROR,
  payload: message,
});

export const fetchParentCategories = (data) => ({
  type: FETCH_PARENT_CATEGORIES,
  payload: data,
});

export const fetchParentCategoriesSuccess = (user) => ({
  type: FETCH_PARENT_CATEGORIES_SUCCESS,
  payload: user,
});

export const fetchParentCategoriesError = (message) => ({
  type: FETCH_PARENT_CATEGORIES_ERROR,
  payload: message,
});

export const fetchBrands = (data) => ({
  type: FETCH_BRANDS,
  payload: data,
});

export const fetchBrandsSuccess = (user) => ({
  type: FETCH_BRANDS_SUCCESS,
  payload: user,
});

export const fetchBrandsError = (message) => ({
  type: FETCH_BRANDS_ERROR,
  payload: message,
});

export const fetchHighlights = (data) => ({
  type: FETCH_HIGHLIGHTS,
  payload: data,
});

export const fetchHighlightsSuccess = (user) => ({
  type: FETCH_HIGHLIGHTS_SUCCESS,
  payload: user,
});

export const fetchHighlightsError = (message) => ({
  type: FETCH_HIGHLIGHTS_ERROR,
  payload: message,
});

export const mostPopular = (data) => ({
  type: MOST_POPULAR,
  payload: data,
});

export const mostPopularSuccess = (user) => ({
  type: MOST_POPULAR_SUCCESS,
  payload: user,
});

export const mostPopularError = (message) => ({
  type: MOST_POPULAR_ERROR,
  payload: message,
});

export const fetchCategoryTree = (data) => ({
  type: FETCH_CATEGORY_TREE,
  payload: data,
});

export const fetchCategoryTreeSuccess = (user) => ({
  type: FETCH_CATEGORY_TREE_SUCCESS,
  payload: user,
});

export const fetchCategoryTreeError = (message) => ({
  type: FETCH_CATEGORY_TREE_ERROR,
  payload: message,
});

export const fetchCategoryFilters = (data) => ({
  type: FETCH_CATEGORY_FILTERS,
  payload: data,
});

export const fetchCategoryFiltersSuccess = (user) => ({
  type: FETCH_CATEGORY_FILTERS_SUCCESS,
  payload: user,
});

export const fetchCategoryFiltersError = (message) => ({
  type: FETCH_CATEGORY_FILTERS_ERROR,
  payload: message,
});

export const fetchDailyDeals = (data) => ({
  type: FETCH_DAILY_DEALS,
  payload: data,
});

export const fetchDailyDealsSuccess = (user) => ({
  type: FETCH_DAILY_DEALS_SUCCESS,
  payload: user,
});

export const fetchDailyDealsError = (message) => ({
  type: FETCH_DAILY_DEALS_ERROR,
  payload: message,
});

export const fetchCouponDetails = (data) => ({
  type: FETCH_COUPON_DETAILS,
  payload: data,
});

export const fetchCouponDetailsSuccess = (user) => ({
  type: FETCH_COUPON_DETAILS_SUCCESS,
  payload: user,
});

export const fetchCouponDetailsError = (message) => ({
  type: FETCH_COUPON_DETAILS_ERROR,
  payload: message,
});
